import { render, staticRenderFns } from "./GrowthRateReport.vue?vue&type=template&id=80f16a34&scoped=true"
import script from "./GrowthRateReport.vue?vue&type=script&lang=js"
export * from "./GrowthRateReport.vue?vue&type=script&lang=js"
import style0 from "./GrowthRateReport.vue?vue&type=style&index=0&id=80f16a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f16a34",
  null
  
)

export default component.exports